import type { AnswerState, ICState } from 'schema/state';
import { findLastInStack, pushToStack } from '../../utils';

export interface UpdateMediaProgressActionParams {
  questionId: string;
  progress: number;
  touchedBy: NonNullable<AnswerState['lastTouchedBy']>;
}

export function updateMediaProgress(
  prevState: ICState,
  { questionId, progress, touchedBy }: UpdateMediaProgressActionParams,
): ICState {
  const found = findLastInStack(prevState.answersStack, questionId);

  const answerState: typeof found = {
    ...found,
    lastTouchedBy: touchedBy,
    isTimeExpired: found.isTimeExpired === 'unchangedSinceExpired' ? 'changedSinceExpired' : found.isTimeExpired,
    ...(progress >= (found.mediaProgress ?? 0) && { mediaProgress: progress }),
  };

  const answersStack = pushToStack(prevState.answersStack, answerState);
  const state = { ...prevState, answersStack };

  if (!state.startedAt) state.startedAt = new Date().getTime();

  return state;
}
